import React from 'react';
import { useNavigate, Link } from 'react-router-dom';
import axios from 'axios';
import Header from '../../components/layout/Header';
import Footer from '../../components/layout/Footer';
import Input from '../../components/ui/Input';
import Button from '../../components/ui/Button';
import Icon from '../../components/AppIcon';

const Signup = () => {
    const navigate = useNavigate();
    const [formData, setFormData] = React.useState({
        name: '',
        email: '',
        password: '',
        company_name: ''
    });
    const [loading, setLoading] = React.useState(false);
    const [error, setError] = React.useState(null);
    const [success, setSuccess] = React.useState(false);

    const API_URL = import.meta.env.VITE_API_URL || 'http://localhost/isplw/api';

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError(null);

        try {
            const response = await axios.post(`${API_URL}/auth.php`, {
                action: 'signup',
                ...formData
            });

            if (response.data.status === 'success') {
                setSuccess(true);
                setTimeout(() => {
                    navigate('/login');
                }, 2000);
            }
        } catch (err) {
            setError(err.response?.data?.message || "An error occurred during signup.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="min-h-screen bg-background flex flex-col">
            <Header />
            <main className="flex-1 flex items-center justify-center py-12 px-4 md:px-6 mt-16">
                <div className="max-w-md w-full bg-card rounded-2xl shadow-xl border border-border p-8 md:p-10">
                    <div className="text-center mb-8">
                        <div className="w-16 h-16 bg-primary/10 rounded-2xl flex items-center justify-center mx-auto mb-4 text-primary">
                            <Icon name="UserPlus" size={32} />
                        </div>
                        <h1 className="text-2xl md:text-3xl font-bold text-foreground mb-2">Create an Account</h1>
                        <p className="text-muted-foreground">Join InChi Solutions Pvt Ltd Hub as a client partner</p>
                    </div>

                    {success ? (
                        <div className="bg-success/10 border border-success/20 text-success p-4 rounded-lg flex items-center gap-3 mb-6">
                            <Icon name="CheckCircle" size={20} />
                            <p className="font-medium">Registration successful! Redirecting to login...</p>
                        </div>
                    ) : (
                        <form onSubmit={handleSubmit} className="space-y-4">
                            {error && (
                                <div className="bg-error/10 border border-error/20 text-error p-3 rounded-lg flex items-center gap-2 text-sm italic">
                                    <Icon name="AlertCircle" size={16} />
                                    {error}
                                </div>
                            )}

                            <Input
                                label="Full Name"
                                name="name"
                                placeholder="John Doe"
                                value={formData.name}
                                onChange={handleChange}
                                required
                            />

                            <Input
                                label="Email Address"
                                name="email"
                                type="email"
                                placeholder="john@example.com"
                                value={formData.email}
                                onChange={handleChange}
                                required
                            />

                            <Input
                                label="Company Name"
                                name="company_name"
                                placeholder="TechVision Solutions"
                                value={formData.company_name}
                                onChange={handleChange}
                            />

                            <Input
                                label="Password"
                                name="password"
                                type="password"
                                placeholder="••••••••"
                                value={formData.password}
                                onChange={handleChange}
                                required
                            />

                            <Button
                                type="submit"
                                variant="default"
                                className="w-full"
                                loading={loading}
                            >
                                Sign Up
                            </Button>

                            <p className="text-center text-sm text-muted-foreground mt-6">
                                Already have an account?{' '}
                                <Link to="/login" className="text-primary font-semibold hover:underline">
                                    Log In
                                </Link>
                            </p>
                        </form>
                    )}
                </div>
            </main>
            <Footer />
        </div>
    );
};

export default Signup;
